<!--
 * @Author: xuesong
 * @Date: 2021-04-20 15:47:33
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-07-02 15:56:14
 * @Description: 
-->
<template>
  <div>
    <el-popover placement="top-start" :width="popverWidth" trigger="manual"  v-model="visiblePop">
      <!-- 更多 -->
      <div class="isMore">
        <div class="isMore-item">
          <div class="image">
            <img src="../../static/IMInput/file.png" />
          </div>
          <div style="color:#000;font-weight:blod;font-size:12px">发送文件</div>
          <input
            type="file"
            style="
              background: none;
              outline: none;
              border: none;
              opacity: 0;
              overfloow: hidden;
              position: absolute;
              z-index:9999;
              width: 80px;
              height: 60px;
              left: 34px;
              top: 12px;
              cursor: pointer;
            "
            @change="uploadFile($event)"
          />
        </div>
        <div
          class="isMore-item"
          v-for="(item, index) in popoverList"
          :key="index"
          @click="openMore(item.id)"
        >
          <div class="image">
            <img :src="item.icon" />
          </div>
          <div style="color:#000;font-weight:blod;font-size:12px">{{ item.name }}</div>
        </div>
        <div class="isMore-item" v-if="isEndConsultation" @click="endConsultation">
            <div style="font-size:30px;text-align:center;" class="el-icon-switch-button"></div>
            <div style="font-size:11px;margin-top: 2px;">结束咨询</div>
        </div>
      </div>

      <div slot="reference" :class="iconClass" @click="closePopver" style="color: #666666;">
        
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    // 传入的数据
    popoverList: {
      type: Array,
      default: [],
    },
    // 如果是更多的icon
    isMore: {
      type: Boolean,
      default: false,
    },
    // 如果是常用语句
    isOveruse: {
      type: Boolean,
      default: false,
    },
    // icon 的样式
    iconClass: {
      type: String,
      default: '',
    },
    popverWidth: {
      type: Number,
      default: 150,
    },
    // 控制显示开关
    visiblePop: {
      type: Boolean,
      default: false,
    },
    isEndConsultation:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
       
    }
  },
  methods: { 
    openMore(item) {
      this.$emit('openMore', item)
    },
    uploadFile(e) {
      this.$emit('uploadFile',e)
	  setTimeout(()=>{
		  e.target.value = '';
	  },2000);
	  
    },
    closePopver() { 
      this.$emit('closePopver') 
    }, 
    endConsultation(){
      this.$emit('endConsultation')
    }
  },
}
</script>

<style scoped lang="less">
.isMore {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  .isMore-item{
    width: 25%;
    text-align: center;
    margin-bottom: 10px;
    .image{
      height: 40px;
      width: 40px;
      border-radius: 50%;
      // background: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      cursor: pointer;
      margin-bottom: 5px;
      z-index: 2000;
      background: #363F4D;
      img{
        height: 16px;
        width: 16px;
      }
      &:hover{
        background:dodgerblue;
        color: #fff;
      }
    }
  }
}
</style>
